import { create } from 'zustand'
import { api } from './api'

export interface CurrentUser {
  id: string
  email: string
  full_name: string
  role: 'admin' | 'manager' | 'user'
  department_id: string | null
  business_unit_id: string | null
  must_change_password: boolean
}

interface AuthState {
  user: CurrentUser | null
  loading: boolean
  load: () => Promise<void>
  login: (email: string, password: string) => Promise<void>
  logout: () => Promise<void>
}

export const useAuth = create<AuthState>((set) => ({
  user: null,
  loading: true,
  load: async () => {
    try {
      const u = await api<CurrentUser>('/api/auth/me')
      set({ user: u, loading: false })
    } catch {
      set({ user: null, loading: false })
    }
  },
  login: async (email, password) => {
    await api('/api/auth/login', {
      method: 'POST',
      body: JSON.stringify({ email, password }),
    })
    const u = await api<CurrentUser>('/api/auth/me')
    set({ user: u })
  },
  logout: async () => {
    await api('/api/auth/logout', { method: 'POST' })
    set({ user: null })
  },
}))
